export const cartItemType = {
    BteOnly: 1,
    RicWithStockReceiver: 2,
    Custom: 3,
    Earmold: 4,
    BteWithEarmold: 5,
    RicWithEarmold: 6,
    ApReceiver: 7,
    RicWithAp: 8,
    FacePlates: 9,
    AMP: 30,
    Accessory: 40,
    Supply: 50,
    StockReceiver: 55,
    SparePart: 60,
    Literature: 70,
    SoundGear: 80,
    SoundGearCustom: 83,
    SoundGearEarmold: 84,
    DashTailored: 85,
};

export const cartItemTypeIdsThatCanBeDirectlyAddedToCart = [
    cartItemType.FacePlates,
    cartItemType.Accessory,
    cartItemType.Supply,
    cartItemType.SparePart,
    cartItemType.Literature,
];

export const cartItemTypeIdsWithoutProductDetailsPage = [
    cartItemType.FacePlates,
    cartItemType.Accessory,
    cartItemType.Supply,
    cartItemType.StockReceiver,
    cartItemType.SparePart,
    cartItemType.Literature,
];

export const cartItemTypeIdsWithoutDisplayingPartNumber = [
    cartItemType.Custom,
    cartItemType.Earmold,
    cartItemType.ApReceiver,
    cartItemType.SoundGearCustom,
    cartItemType.SoundGearEarmold,
    cartItemType.DashTailored,
];
